export const onNodesDeleteCallback =
  ({ setIsPanelOpened, api }) =>
  async (nodes) => {
    setIsPanelOpened(false);
    for (var k = 0; k < nodes.length; k++) {
      const node = nodes[k];
      if (node.data?.nodeId) {
        try {
          await api.flowNode.delete(node.data?.nodeId);
        } catch (e) {
          console.error(`Unable to delete node ${e}`);
        }
      }

      try {
        if (node.type === "message" && node.data?.messageSkeletonId) {
          await api.messageSkeleton.delete(node.data?.messageSkeletonId);
        } else if (node.type === "template" && node.data?.messageSkeletonId) {
          await api.messageSkeleton.delete(node.data?.messageSkeletonId);
        } else if (node.type === "template" && node.data?.whatsappTemplateId) {
          await api.whatsappTemplate.delete(node.data?.whatsappTemplateId);
        } else if (node.type === "wait" && node.data?.waitingNodeId) {
          await api.waitingNode.delete(node.data?.waitingNodeId);
        } else if (node.type === "ai" && node.data?.aiConfigurationId) {
          await api.aiConfiguration.delete(node.data?.aiConfigurationId);
        }
      } catch (e) {
        console.error(`Unable to delete node ${e}`);
      }

      for (let index = 0; index < (node.data?.buttons ?? []).length; index++) {
        const b = node.data.buttons[index];

        if (b?.gadgetId) {
          try {
            await api.flowNode.delete(b?.gadgetId);
          } catch (e) {
            console.error(`Unable to delete node ${e}`);
          }
        }
        if (b?.replyButtonGadgetId) {
          try {
            await api.replyButton.delete(b?.replyButtonGadgetId);
          } catch (e) {
            console.error(`Unable to delete the reply button ${e}`);
          }
        } else if (b?.replyListGadgetId) {
          try {
            await api.replyList.delete(b?.replyListGadgetId);
          } catch (e) {
            console.error(`Unable to delete the reply list ${e}`);
          }
        }
      }

      if (node.data?.urlButton?.gadgetId) {
        try {
          await api.flowNode.delete(node.data.urlButton.gadgetId);
        } catch (e) {
          console.error(`Unable to delete the url button ${e}`);
        }
      }
      if (node.data?.urlButton2?.gadgetId) {
        try {
          await api.flowNode.delete(node.data.urlButton2.gadgetId);
        } catch (e) {
          console.error(`Unable to delete the url button 2 ${e}`);
        }
      }
      if (node.data?.flowButton?.gadgetId) {
        try {
          await api.flowNode.delete(node.data.flowButton.gadgetId);
        } catch (e) {
          console.error(`Unable to delete the flow button ${e}`);
        }
      }
    }
  };
